module.exports = __webpack_public_path__ + "static/media/Hunters-Park-Bylaws.fa107117.pdf";